import type { InboxFeatureBannerConfig } from '@/constants/inboxFeatureBanners';
import { useInboxFeatureBanner } from '@/hooks/inbox/useInboxFeatureBanner';
import {
  useInboxFeatureBannerAnnouncementId,
  useInboxFeatureBannerHasContent,
} from '@/hooks/inbox/useInboxFeatureBannerContent';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export function useInboxAnnouncementBanner({
  enabled,
  userId,
  bannerConfig,
}: {
  enabled: boolean;
  userId?: string;
  bannerConfig: InboxFeatureBannerConfig;
}) {
  const isInboxAnnouncementBannerEnabled = useFeatureFlag(bannerConfig.featureFlag);

  const hasBannerContent = useInboxFeatureBannerHasContent(bannerConfig);

  const announcementId = useInboxFeatureBannerAnnouncementId(bannerConfig);

  const dismissStorageKey = announcementId
    ? `${bannerConfig.dismissStorageKey}:${announcementId}`
    : bannerConfig.dismissStorageKey;

  return useInboxFeatureBanner({
    enabled: enabled && isInboxAnnouncementBannerEnabled && hasBannerContent,
    userId,
    dismissStorageKey,
  });
}
